/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  AddProductToCartRequest,
  CartItemCountDto,
  CartShopDto,
  CheckoutSummaryDto,
  SetCartDeliveryRequest,
  SetCartGiftRequest,
  SetProductQuantityRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getCartShopV1Response200 = {
  data: CartShopDto
  status: 200
}

export type getCartShopV1Response401 = {
  data: void
  status: 401
}

export type getCartShopV1ResponseSuccess = (getCartShopV1Response200) & {
  headers: Headers;
};
export type getCartShopV1ResponseError = (getCartShopV1Response401) & {
  headers: Headers;
};

export type getCartShopV1Response = (getCartShopV1ResponseSuccess | getCartShopV1ResponseError)

export const getGetCartShopV1Url = () => {




  return `/api/v1/me/cart/shop`
}

/**
 * Returns the active shop cart (the latest cart Order with Category = Fashion). Returns an empty cart object if none exists yet.
 * @summary Get current user's shop cart
 */
export const getCartShopV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getCartShopV1Response> => {

  return customFetch<getCartShopV1Response>(getGetCartShopV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type clearCartShopV1Response204 = {
  data: void
  status: 204
}

export type clearCartShopV1Response401 = {
  data: void
  status: 401
}

export type clearCartShopV1ResponseSuccess = (clearCartShopV1Response204) & {
  headers: Headers;
};
export type clearCartShopV1ResponseError = (clearCartShopV1Response401) & {
  headers: Headers;
};

export type clearCartShopV1Response = (clearCartShopV1ResponseSuccess | clearCartShopV1ResponseError)

export const getClearCartShopV1Url = () => {




  return `/api/v1/me/cart/shop`
}

/**
 * Removes all items from the cart. Idempotent — returns 204 even if the cart was already empty.
 * @summary Clear cart
 */
export const clearCartShopV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<clearCartShopV1Response> => {

  return customFetch<clearCartShopV1Response>(getClearCartShopV1Url(),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type startCartShopCheckoutV1Response200 = {
  data: CheckoutSummaryDto
  status: 200
}

export type startCartShopCheckoutV1Response401 = {
  data: void
  status: 401
}

export type startCartShopCheckoutV1Response409 = {
  data: void
  status: 409
}

export type startCartShopCheckoutV1Response410 = {
  data: void
  status: 410
}

export type startCartShopCheckoutV1ResponseSuccess = (startCartShopCheckoutV1Response200) & {
  headers: Headers;
};
export type startCartShopCheckoutV1ResponseError = (startCartShopCheckoutV1Response401 | startCartShopCheckoutV1Response409 | startCartShopCheckoutV1Response410) & {
  headers: Headers;
};

export type startCartShopCheckoutV1Response = (startCartShopCheckoutV1ResponseSuccess | startCartShopCheckoutV1ResponseError)

export const getStartCartShopCheckoutV1Url = () => {




  return `/api/v1/me/cart/shop/checkout`
}

/**
 * RETIRED: always answers 410 checkout_requires_payment. It used to close the order without taking any payment and without CPI steps 6-7, producing sales the POS never saw. In the shop there is always a payment. Use POST /me/checkout/payment-intents with context 'shop' and the cart PublicGuid, confirm with Stripe.js, then poll GET /me/checkout/payments/{paymentId} — the order is closed by Stripe's webhook. The 409 prices_changed response is unchanged there, same body with the repriced cart. Do NOT clear the cart after confirming: the cart becomes the order. This route is deleted once the client has migrated.
 * @summary Start checkout — RETIRED, always 410
 */
export const startCartShopCheckoutV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<startCartShopCheckoutV1Response> => {

  return customFetch<startCartShopCheckoutV1Response>(getStartCartShopCheckoutV1Url(),
  {
    ...options,
    method: 'POST'


  }
);}


export type getCartShopItemCountV1Response200 = {
  data: CartItemCountDto
  status: 200
}

export type getCartShopItemCountV1Response401 = {
  data: void
  status: 401
}

export type getCartShopItemCountV1ResponseSuccess = (getCartShopItemCountV1Response200) & {
  headers: Headers;
};
export type getCartShopItemCountV1ResponseError = (getCartShopItemCountV1Response401) & {
  headers: Headers;
};

export type getCartShopItemCountV1Response = (getCartShopItemCountV1ResponseSuccess | getCartShopItemCountV1ResponseError)

export const getGetCartShopItemCountV1Url = () => {




  return `/api/v1/me/cart/shop/count`
}

/**
 * Returns the total number of product units in the user's shop cart (sum of line quantities, excluding the free gift box). Lightweight — does not re-price against CPI. Returns 0 when there is no cart. Intended for the cart badge.
 * @summary Get shop cart item count
 */
export const getCartShopItemCountV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getCartShopItemCountV1Response> => {

  return customFetch<getCartShopItemCountV1Response>(getGetCartShopItemCountV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type setCartShopDeliveryV1Response200 = {
  data: CartShopDto
  status: 200
}

export type setCartShopDeliveryV1Response400 = {
  data: void
  status: 400
}

export type setCartShopDeliveryV1Response401 = {
  data: void
  status: 401
}

export type setCartShopDeliveryV1Response404 = {
  data: void
  status: 404
}

export type setCartShopDeliveryV1ResponseSuccess = (setCartShopDeliveryV1Response200) & {
  headers: Headers;
};
export type setCartShopDeliveryV1ResponseError = (setCartShopDeliveryV1Response400 | setCartShopDeliveryV1Response401 | setCartShopDeliveryV1Response404) & {
  headers: Headers;
};

export type setCartShopDeliveryV1Response = (setCartShopDeliveryV1ResponseSuccess | setCartShopDeliveryV1ResponseError)

export const getSetCartShopDeliveryV1Url = () => {




  return `/api/v1/me/cart/shop/delivery`
}

/**
 * Sets or changes how the cart is fulfilled: 'delivery' to a saved address (addressId) or 'pickup' at a pickup point (pickupPointId). Returns 404 if the address is not found or the user has no cart.
 * @summary Set the cart delivery method
 */
export const setCartShopDeliveryV1 = async (setCartDeliveryRequest: SetCartDeliveryRequest, options?: Parameters<typeof customFetch>[1]): Promise<setCartShopDeliveryV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setCartShopDeliveryV1Response>(getSetCartShopDeliveryV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCartDeliveryRequest)
  }
);}


export type setCartShopGiftV1Response200 = {
  data: CartShopDto
  status: 200
}

export type setCartShopGiftV1Response400 = {
  data: void
  status: 400
}

export type setCartShopGiftV1Response401 = {
  data: void
  status: 401
}

export type setCartShopGiftV1Response404 = {
  data: void
  status: 404
}

export type setCartShopGiftV1ResponseSuccess = (setCartShopGiftV1Response200) & {
  headers: Headers;
};
export type setCartShopGiftV1ResponseError = (setCartShopGiftV1Response400 | setCartShopGiftV1Response401 | setCartShopGiftV1Response404) & {
  headers: Headers;
};

export type setCartShopGiftV1Response = (setCartShopGiftV1ResponseSuccess | setCartShopGiftV1ResponseError)

export const getSetCartShopGiftV1Url = () => {




  return `/api/v1/me/cart/shop/gift`
}

/**
 * Adds the free gift box to the cart (if not present) and sets the personal gift message. Idempotent — call again to update the message. The gift box image/labels are editorial (Umbraco) and rendered by the client. Returns 404 if the user has no shop cart yet.
 * @summary Add or update the cart gift
 */
export const setCartShopGiftV1 = async (setCartGiftRequest: SetCartGiftRequest, options?: Parameters<typeof customFetch>[1]): Promise<setCartShopGiftV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setCartShopGiftV1Response>(getSetCartShopGiftV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCartGiftRequest)
  }
);}


export type removeCartShopGiftV1Response200 = {
  data: CartShopDto
  status: 200
}

export type removeCartShopGiftV1Response401 = {
  data: void
  status: 401
}

export type removeCartShopGiftV1ResponseSuccess = (removeCartShopGiftV1Response200) & {
  headers: Headers;
};
export type removeCartShopGiftV1ResponseError = (removeCartShopGiftV1Response401) & {
  headers: Headers;
};

export type removeCartShopGiftV1Response = (removeCartShopGiftV1ResponseSuccess | removeCartShopGiftV1ResponseError)

export const getRemoveCartShopGiftV1Url = () => {




  return `/api/v1/me/cart/shop/gift`
}

/**
 * Removes the gift box and clears the gift message, returning the updated cart. Idempotent — succeeds even if no gift was set.
 * @summary Remove the cart gift
 */
export const removeCartShopGiftV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<removeCartShopGiftV1Response> => {

  return customFetch<removeCartShopGiftV1Response>(getRemoveCartShopGiftV1Url(),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type addCartShopProductV1Response201 = {
  data: CartShopDto
  status: 201
}

export type addCartShopProductV1Response400 = {
  data: void
  status: 400
}

export type addCartShopProductV1Response401 = {
  data: void
  status: 401
}

export type addCartShopProductV1Response404 = {
  data: void
  status: 404
}

export type addCartShopProductV1Response409 = {
  data: void
  status: 409
}

export type addCartShopProductV1ResponseSuccess = (addCartShopProductV1Response201) & {
  headers: Headers;
};
export type addCartShopProductV1ResponseError = (addCartShopProductV1Response400 | addCartShopProductV1Response401 | addCartShopProductV1Response404 | addCartShopProductV1Response409) & {
  headers: Headers;
};

export type addCartShopProductV1Response = (addCartShopProductV1ResponseSuccess | addCartShopProductV1ResponseError)

export const getAddCartShopProductV1Url = () => {




  return `/api/v1/me/cart/shop/products`
}

/**
 * Adds a catalog product variant to the cart, resolving name/price/image/stock server-side from the variant. Creates the cart if it does not exist. If the same variant is already in the cart, its quantity is incremented.
 * @summary Add catalog product to cart
 */
export const addCartShopProductV1 = async (addProductToCartRequest: AddProductToCartRequest, options?: Parameters<typeof customFetch>[1]): Promise<addCartShopProductV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<addCartShopProductV1Response>(getAddCartShopProductV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addProductToCartRequest)
  }
);}


export type setCartShopProductQuantityV1Response200 = {
  data: CartShopDto
  status: 200
}

export type setCartShopProductQuantityV1Response400 = {
  data: void
  status: 400
}

export type setCartShopProductQuantityV1Response401 = {
  data: void
  status: 401
}

export type setCartShopProductQuantityV1Response404 = {
  data: void
  status: 404
}

export type setCartShopProductQuantityV1Response409 = {
  data: void
  status: 409
}

export type setCartShopProductQuantityV1ResponseSuccess = (setCartShopProductQuantityV1Response200) & {
  headers: Headers;
};
export type setCartShopProductQuantityV1ResponseError = (setCartShopProductQuantityV1Response400 | setCartShopProductQuantityV1Response401 | setCartShopProductQuantityV1Response404 | setCartShopProductQuantityV1Response409) & {
  headers: Headers;
};

export type setCartShopProductQuantityV1Response = (setCartShopProductQuantityV1ResponseSuccess | setCartShopProductQuantityV1ResponseError)

export const getSetCartShopProductQuantityV1Url = (variantId: string,) => {




  return `/api/v1/me/cart/shop/products/${variantId}`
}

/**
 * Sets the quantity of a product (by its variant id) in the shop cart. Returns 404 if the variant is not in the user's cart or no longer available; 409 if the quantity exceeds known stock.
 * @summary Set shop cart product quantity
 */
export const setCartShopProductQuantityV1 = async (variantId: string,
    setProductQuantityRequest: SetProductQuantityRequest, options?: Parameters<typeof customFetch>[1]): Promise<setCartShopProductQuantityV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setCartShopProductQuantityV1Response>(getSetCartShopProductQuantityV1Url(variantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setProductQuantityRequest)
  }
);}


export type removeCartShopProductV1Response200 = {
  data: CartShopDto
  status: 200
}

export type removeCartShopProductV1Response401 = {
  data: void
  status: 401
}

export type removeCartShopProductV1Response404 = {
  data: void
  status: 404
}

export type removeCartShopProductV1ResponseSuccess = (removeCartShopProductV1Response200) & {
  headers: Headers;
};
export type removeCartShopProductV1ResponseError = (removeCartShopProductV1Response401 | removeCartShopProductV1Response404) & {
  headers: Headers;
};

export type removeCartShopProductV1Response = (removeCartShopProductV1ResponseSuccess | removeCartShopProductV1ResponseError)

export const getRemoveCartShopProductV1Url = (variantId: string,) => {




  return `/api/v1/me/cart/shop/products/${variantId}`
}

/**
 * Removes a product (by its variant id) from the shop cart and returns the updated cart, so the client can render it without a follow-up GET. Returns 404 if the variant is not in the user's cart.
 * @summary Remove product from shop cart
 */
export const removeCartShopProductV1 = async (variantId: string, options?: Parameters<typeof customFetch>[1]): Promise<removeCartShopProductV1Response> => {

  return customFetch<removeCartShopProductV1Response>(getRemoveCartShopProductV1Url(variantId),
  {
    ...options,
    method: 'DELETE'


  }
);}


